import { LOGIN, RESET_PASSWORD, LOGOUT, PRIVATE, PRIVATE_ADMIN, PRIVATE_USER, ORGANIGRAMA, VACACIONES, EXTRAS, EXTRAS_ORGANIGRAMA, CORPORATE_DOCUMENTS } from 'Shared/Routing/Application/Constants/PathsConstant';
import Login from 'Shared/Security/Application/Views/LoginView';
import ResetPasswordView from 'Shared/Security/Application/Views/ResetPasswordView';
import Logout from 'Shared/Security/Application/Routings/Logout';
import PrivateRedirector from 'Shared/Security/Application/Routings/PrivateRedirector';
import PublicRedirector from 'Shared/Security/Application/Routings/PublicRedirector';
import AdminRoute from 'Shared/Routing/Application/Routes/AdminRoute';
import PrivateRoute from 'Shared/Routing/Application/Routes/PrivateRoute';
import PublicRoute from 'Shared/Routing/Application/Routes/PublicRoute';
import UserRoute from 'Shared/Routing/Application/Routes/UserRoute';
import PermissionRoute from 'Shared/Routing/Application/Routes/PermissionRoute';
import ExtraRoute from 'Shared/Routing/Application/Routes/ExtraRoute';
import { UserRouter } from 'User/Application/Routers/UserRouter';
import { AdminRouter } from 'User/Application/Routers/AdminRouter';
import { PermissionRouter } from 'Permission/Application/Routers/PermissionRouter';
import { PermissionGroupRouter } from 'PermissionGroup/Application/Routers/PermissionGroupRouter';
import { JobPositionRouter } from 'JobPosition/Application/Routers/JobPositionRouter';
import { ScheduledCommandRouter } from 'ScheduledCommand/Application/Routers/ScheduledCommandRouter';
import { OrgChartRouter, OrgChartUserRouter } from 'OrgChart/Application/Routers/OrgChartRouter';
import PublicOrgChartView from 'OrgChart/Application/Views/PublicOrgChartView';
import VacacionesOrgChartView from 'OrgChart/Application/Views/VacacionesOrgChartView';
import ExtrasOrgChartView from 'OrgChart/Application/Views/ExtrasOrgChartView';
import { AfterSalesExtraRouter } from 'Extra/AfterSalesExtra/Application/Routers/AfterSalesExtraRouter';
import { InstallationExtraRouter } from 'Extra/InstallationExtra/Application/Routers/InstallationExtraRouter';
import ExtrasView from 'Extra/Common/UI/Views/ExtrasView';
import { EXTRAS as EXTRAS_PERMISSION, EXTRAS_EMPLOYE, EXTRAS_VALIDATOR } from 'Shared/Security/Application/Constants/PermissionsConstant';
import CorporateDocumentsView from 'CorporateDocument/Application/Views/CorporateDocumentsView';

export const AppRouter = [
    {
      path: PRIVATE,
      element: <PrivateRoute />,
      children: [
        {
          index: true,
          element: <PrivateRedirector />
        },
        {
          path: ORGANIGRAMA,
          element: <UserRoute />,
          children: [
            {
              index: true,
              element: <PublicOrgChartView />
            },
            {
              path: EXTRAS_ORGANIGRAMA,
              element: <ExtrasOrgChartView />
            }
          ]
        },
        {
          path: VACACIONES,
          element: <UserRoute />,
          children: [
            {
              index: true,
              element: <VacacionesOrgChartView />
            }
          ]
        },
        {
          path: EXTRAS,
          element: <UserRoute />,
          children: [
            {
              path: '',
              element: <PermissionRoute permission={[EXTRAS_EMPLOYE, EXTRAS_VALIDATOR, EXTRAS_PERMISSION]} />,
              children: [
                {
                  index: true,
                  element: <ExtrasView />
                }
              ]
            }
          ]
        },
        {
          path: CORPORATE_DOCUMENTS,
          element: <UserRoute />,
          children: [
            {
              index: true,
              element: <CorporateDocumentsView />
            }
          ]
        },
        {
          path: PRIVATE_USER,
          element: <UserRoute />,          children: [
            ...UserRouter,
            ...OrgChartUserRouter
          ]
        },
        {
          path: PRIVATE_ADMIN,
          element: <AdminRoute />,
          children: [
            ...AdminRouter
            ,
            ...PermissionRouter
            ,
            ...PermissionGroupRouter
            ,
            ...JobPositionRouter
            ,
            ...ScheduledCommandRouter
            ,
            ...OrgChartRouter
          ]
        },
        {
          element: <UserRoute />,
          children: [
            {
              element: <ExtraRoute />,
              children: [
                ...AfterSalesExtraRouter
                ,
                ...InstallationExtraRouter
              ]
            }
          ]
        },
        {
          path: LOGOUT,
          element: <Logout />
        }
      ]
    },
    {
      path: '/',
      element: <PublicRoute />,
      children: [
        {
          index: true,
          element: <PublicRedirector />
        },
        {
          path: LOGIN,
          element: <Login />
        },
        {
          path: RESET_PASSWORD,
          element: <ResetPasswordView />
        }
      ]
    }
];
